import { createContext, useContext } from 'react';

import type { SharedTrackingFns } from '@web-platform/shared-universal-types-tracking/src/SharedTrackingFns';

const SharedTracking = createContext<SharedTrackingFns | null>(null);

export const SharedTrackingProvider = SharedTracking.Provider;

export const useSharedTracking = () => {
  const trackingFns = useContext(SharedTracking);

  if (!trackingFns) {
    throw new Error('SharedTrackingContext: trackingFns were null');
  }

  return trackingFns;
};
